import { cn } from '@gozoki/ui/lib/utils'
import closeIcon from '~/assets/dashboard/close.svg'

// Bouton de fermeture partagé des modales. Le visuel reste la pastille blanche 28px + croix 14px du
// Figma (le <span> interne) ; le bouton lui-même est transparent et élargit la zone tactile à 44px
// via p-[8px] -m-[8px] (cible doigt kiosk PCAP) sans décaler la pastille ni la mise en page (la
// marge négative annule le padding). Les modales sont montées hors du transform: scale, donc ces px
// sont les px écran réels : une pastille 28px seule serait sous la cible tactile.
// Variante `square` : la croix carrée 40 px des modales à la DA « C.A 7 jours » (déjà au-dessus de
// la cible tactile, d'où une marge réduite).
export function ModalCloseButton({
  onClose,
  ariaLabel = 'Fermer',
  className,
  variant = 'round',
}: {
  onClose: () => void
  ariaLabel?: string
  className?: string
  variant?: 'round' | 'square'
}) {
  const square = variant === 'square'
  return (
    <button
      type="button"
      onClick={onClose}
      aria-label={ariaLabel}
      className={cn(
        'shrink-0 cursor-pointer',
        square ? 'p-[2px] -m-[2px]' : 'p-[8px] -m-[8px]',
        className,
      )}
    >
      <span
        className={cn(
          'flex items-center justify-center',
          square
            ? 'size-[40px] rounded-[8px] bg-[#F9F8F1]'
            : 'size-[28px] rounded-[14px] border border-[#D7D7D7] bg-white',
        )}
      >
        <img
          src={closeIcon}
          alt=""
          aria-hidden
          className={square ? 'size-[16px]' : 'size-[14px]'}
        />
      </span>
    </button>
  )
}
